export default __webpack_public_path__ + "static/media/ic_lang.62e3577b.svg";